import CubeIcon from "@redotech/redo-icons/cube-01.svg";
import { FulfillmentGroupPickStatus } from "@redotech/redo-model/fulfillments/fulfillment-group";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const pickStatusFilterName = "pickStatus" as const;

export const PickStatusArrayFilter = (): ArrayStringTableFilter<string> => ({
  type: AdvancedFilterType.ARRAY_TO_STRING,
  Icon: CubeIcon,
  operators: [
    ArrayStringFilterOperator.ANY_OF,
    ArrayStringFilterOperator.NONE_OF,
  ],
  data: {
    name: pickStatusFilterName,
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "pick status",
  itemLabelPlural: "pick statuses",
  display: (item: string) => {
    switch (item) {
      case FulfillmentGroupPickStatus.PICKED:
        return "Picked";
      case FulfillmentGroupPickStatus.PROBLEM:
        return "Problem";
      case FulfillmentGroupPickStatus.IN_PROGRESS:
        return "In Progress";
      default:
        return item;
    }
  },
  displayName: "Pick Status",
  valueFetcher: async () => {
    // Return all possible pick statuses
    return Object.values(FulfillmentGroupPickStatus);
  },
});
